export const environment = {
  production: false,
  apiUrl: 'https://domunadev-c2f4aeazfsbsa0c7.centralus-01.azurewebsites.net/api/',
  googleMapsApiKey: 'AIzaSyCYEJBfj1sOQQrNz5L8Rz8xYv_WVgjqJUg',
  onesignal: {
    web: '',
  },
  endpoints: {
    login: 'loginUserAdmin',
    validateToken: 'userAdminByToken',
    sendRecoveryCode: 'sendRecoveryCode',
    changePassword: 'changePassword',
    verifyPassword: 'userAdminPasswordValidate',
    userAdmin: {
      base: 'userAdminList',
      suffix: 'admin',
      types: 'userAdminTypeList',
      getById: 'userAdmin',
      create: 'userAdminCreate',
      update: 'userAdminUpdate',
      delete: 'userAdminDelete',
      updatePassword: 'userAdminUpdatePassword',
      userAdminSendRecoveryCode: 'userAdminSendRecoveryCode/admin',
    },
    userManager: {
      base: 'userManagerList',
      suffix: 'admin',
      types: 'userManagerTypeList',
      getById: 'userManager',
      create: 'userManagerCreate',
      update: 'userManagerUpdate',
      delete: 'userManagerDelete',
      updatePassword: 'userManagerUpdatePassword',
      userAdminSendRecoveryCode: 'userManagerSendRecoveryCode/admin',
    },
    residentialDevelopment: {
      base: 'residentialDevelopmentList',
      suffix: 'admin',
      getById: 'residentialDevelopment',
      create: 'residentialDevelopmentCreate',
      update: 'residentialDevelopmentUpdate',
      updateFiscalData: 'residentialDevelopmentTaxDetailUpdate',
      updatePaymentData: 'paymentConfigurationUpdate',
      delete: 'residentialDevelopmentDelete',
      updatePassword: 'userManagerUpdatePassword',
      userAdminSendRecoveryCode: 'userManagerSendRecoveryCode/admin',
      houseCondominusMassiveUpload: 'houseCondominusMassiveUpload',
    },
    managersResidentialDevelopment: {
      base: 'userGestorListByResidentialDevelopmentId',
      suffix: 'admin',
      getById: 'userGestorById',
      create: 'userGestorCreate',
      update: 'userGestorUpdate',
      delete: 'userGestorDelete',
      updatePassword: 'userGestorUpdatePassword',
      userGestorSendRecoveryCode: 'userGestorSendRecoveryCode/admin',
    },
    states: {
      base: 'stateList',
      suffix: 'admin',
    },
    cities: {
      base: 'cityListByStateId',
      suffix: 'admin',
    },
    profilesManagers: {
      base: 'userGestorTypeList',
      suffix: 'admin',
      getById: 'userGestorType',
      create: 'userGestorTypeCreate',
      update: 'userGestorTypeUpdate',
      delete: 'userGestorTypeDelete',
    },
    profilesAdmins: {
      base: 'userAdminTypeList',
      suffix: 'admin',
      getById: 'userAdminType',
      create: 'userAdminTypeCreate',
      update: 'userAdminTypeUpdate',
      delete: 'userAdminTypeDelete',
    },
  },
};
